<c-game-base-page [mode]="'edit'" [gameToEdit]="gameToEdit" />
